'use client';
import { useGetLocalizedMedia } from '@/shared/lib/hooks/useGetLocalizedMedia';
import { LocalizedMedia } from '@/shared/model/Language';
import { Media } from '@/shared/ui/media/types';
import { HeroBannerCarousel } from './hero-banner-carousel';
import { HeroBannerProps } from './types';

type Props = HeroBannerProps & {
    data: LocalizedMedia[] | Media[];
    hideWhenEmpty?: boolean;
};
const PLACEHOLDER_BANNER: Media = { url: '/images/placeholder-banner-main.png', alt: '' };

export const HeroBanner = ({ data = [], hideWhenEmpty = false, ...props }: Props) => {
    const getLocalizedMedia = useGetLocalizedMedia();
    const localizedMedia = getLocalizedMedia(data);

    if (hideWhenEmpty && localizedMedia.length === 0) {
        return null;
    }

    return (
        <HeroBannerCarousel data={localizedMedia.length ? localizedMedia : [PLACEHOLDER_BANNER]} {...props} />
    );
};
